import { request } from "./api";

export function payapi(params) {
  const { uuid } = params;
  const queryParams = new URLSearchParams({
    uuid
  }).toString();
  return request({
    url: `https://csweb.xiaodianjia.cn/h5pay/ys/yf_alipccode.php?${queryParams}`,
  });
}



export function payreslut(params) {
  const { uuid } = params;
  const queryParams = new URLSearchParams({
    uuid
  }).toString();
  return request({
    url: `https://csweb.xiaodianjia.cn/h5pay/ys/yf_getresulte.php?${queryParams}`,
  });
}

